import { Link as RouterLink } from 'react-router-dom';
import Link from '@mui/material/Link';
import Button from '@mui/material/Button';
import { useTheme } from "@mui/material";



export default function ButtonsTextGoTo({ to, name, onClick }) {

  const theme = useTheme();

  return (

        <Link component={RouterLink} to={ to }>
              <Button 
                variant="text" 
                size="large"
                onClick={onClick} 
                
                
                sx={{
                          minWidth: {xs: 80, sm: 90, md: 100, lg: 100, xl: 100},
                          p: '10px',
                          color: theme.palette.mode === "light" ? 'common.black' : 'grey.C100',
                          fontWeight: 600,
                          transition: 'transform 0.2s ease',
                    
                          '&:hover': {
                          p: '10px 12px',
                          color: 'common.white',
                          bgcolor: 'greydark.C900',
                          //borderColor: 'greydark.C900',
                          borderRadius: 5,
                          transform: 'scale(1.08)',
                          },

                        }}>
                { name }
              </Button>
        </Link>


  );
}

